export enum AppointmentsAnalyticsEnum {
  APPOINTMENTS_CLICK_EXPORT_GUIDE = '[PAC WEB] Agendamentos - Paciente clicou em "Exportar guia"',
  APPOINTMENTS_CLICK_REQUEST_CANCEL = '[PAC WEB] Agendamentos - Paciente clicou em "Solicitar cancelamento"',
  APPOINTMENTS_OPEN_CANCEL_MODAL = '[PAC WEB] Agendamentos - Modal de cancelamento aberto',
  APPOINTMENTS_CANCEL_MODAL_CHANGE_DATE = '[PAC WEB] Agendamentos - Clicou em "Alterar data e horário" no modal',
  APPOINTMENTS_CANCEL_MODAL_CHANGE_PATIENT = '[PAC WEB] Agendamentos - Clicou em "Trocar paciente" no modal',
  APPOINTMENTS_CANCEL_MODAL_CONFIRM_CANCEL = '[PAC WEB] Agendamentos - Clicou em "Cancelar agendamento" no modal',
  APPOINTMENTS_CANCEL_FORM_SUBMIT = '[PAC WEB] Agendamentos - Formulário de cancelamento enviado',
  APPOINTMENTS_CANCEL_SUCCESS = '[PAC WEB] Agendamentos - Cancelamento solicitado com sucesso',
  APPOINTMENTS_CANCEL_ERROR = '[PAC WEB] Agendamentos - Erro ao solicitar cancelamento',
  APPOINTMENTS_CLICK_CHANGE_PATIENT = '[PAC WEB] Agendamentos - Clicou em "Trocar paciente"',
  APPOINTMENTS_CHANGE_PATIENT_CONFIRM = '[PAC WEB] Agendamentos - Confirmou troca de paciente',
}
